export var StructuredFeedback;
(function (StructuredFeedback) {
    StructuredFeedback[StructuredFeedback["TooBroad"] = 1] = "TooBroad";
    StructuredFeedback[StructuredFeedback["TooSpecific"] = 2] = "TooSpecific";
    StructuredFeedback[StructuredFeedback["TooWordy"] = 3] = "TooWordy";
    StructuredFeedback[StructuredFeedback["IrrelevantTopic"] = 4] = "IrrelevantTopic";
    StructuredFeedback[StructuredFeedback["FalseStatements"] = 5] = "FalseStatements";
    StructuredFeedback[StructuredFeedback["OverGeneralization"] = 6] = "OverGeneralization";
    StructuredFeedback[StructuredFeedback["ToneIssues"] = 7] = "ToneIssues";
    StructuredFeedback[StructuredFeedback["FormattingIssues"] = 8] = "FormattingIssues";
})(StructuredFeedback || (StructuredFeedback = {}));
export const StructuredFeedbackNameMap = {
    [StructuredFeedback.TooBroad]: 'Too Broad',
    [StructuredFeedback.TooSpecific]: 'Too Specific',
    [StructuredFeedback.TooWordy]: 'Too Wordy',
    [StructuredFeedback.IrrelevantTopic]: 'Irrelevant Topic',
    [StructuredFeedback.FalseStatements]: 'False Statements',
    [StructuredFeedback.OverGeneralization]: 'Over Generalization',
    [StructuredFeedback.ToneIssues]: 'Tone Issues',
    [StructuredFeedback.FormattingIssues]: 'Formatting Issues',
};
